<template>
    <div class="modal-overlay" @click.self="closeModal">
      <div class="modal">
        <div class="modal-header">
          <h2>{{ $t('ConditionModal.ConditionOverview') }}</h2>
          <button class="close-button" @click.prevent="closeModal">
            <span class="material-symbols-outlined class-remove">close</span>
          </button>
        </div>
        <div class="divider">
        <label class="headings" for="name">{{ $t('ConditionModal.ConditionName') }}</label>
        <input
          type="text"
          id="name"
          v-model="sharedData.data.props.rules[conditionIndex].conditionName"
          placeholder="enter name"
        />
      </div>
        <!-- Rule Editor: zeigt die vollständige Bedingung -->
        <div class="rule-editor">
          <label class="headings" for="rule">{{ $t('ConditionModal.RuleEditor') }}</label>
          <p class="note">{{ $t('ConditionModal.note') }}</p>
          <textarea spellcheck="false" id="rule" v-model="ruleString" :readonly="sharedData.data.props.rules[conditionIndex].operator == 'else'"> </textarea>
        </div>
        
        
        <!-- Set statement -->
        <div class="divider" :class="{ userRuleInput: !this.sharedData.data.props?.rules[this.conditionIndex].fullCondition }">
        <p class="headings" >{{ $t('ConditionModal.RuleWizard') }}</p>
          <label class="contentLabel" for="statement">{{ $t('ConditionModal.SetStatement') }}</label>
          <select v-model="sharedData.data.props.rules[conditionIndex].statement">
            <option v-for="placeholder in placeholders" :key="placeholder" :value="placeholder">
                {{ placeholder }}
              </option>
          </select>
  
        <!-- Bedingungen (If-Then) -->
          <div class="conditions">
            <label class="ifThen"><em>If:</em></label>
            <div class="setCondition">
            <select class="operatorSelect" v-model="condition.operator">
              <option value="" disabled selected>{{ $t('ConditionModal.Operator') }}</option>
              <option value="=">=</option>
              <option value="!=">!=</option>
              <option value="<">&lt;</option>
              <option value=">">&gt;</option>
              <option value="else">{{ $t('ConditionModal.else') }}</option>
            </select>
            <input 
              class="valueInput"
              type="text"
              v-model="condition.value"
              placeholder="enter value"
              v-if="condition.operator !== 'else'"
            />
          </div>
            <label class="ifThen"><em>then: </em></label>
            <div v-if="!sharedData.data.props.rules[conditionIndex].conditionalBlock">
              <ul>
                <li @click="handleClick('Text', conditionIndex)">
                    <span class="material-symbols-outlined addIcon">text_fields</span>Text
                </li>
                <li @click="handleClick('Heading', conditionIndex)">
                    <span class="material-symbols-outlined addIcon">format_h1</span>Image
                </li>
                <li @click="handleClick('Image', conditionIndex)">
                    <span class="material-symbols-outlined addIcon">image</span>Image
                </li>
                <li @click="handleClick('Html',conditionIndex)">
                    <span class="material-symbols-outlined addIcon">html</span>Ruleset
                </li>
                <li @click="handleClick('Ruleset',conditionIndex)">
                    <span class="material-symbols-outlined addIcon">rule</span>Ruleset
                </li>
              </ul>
            </div>
  
            <div v-else class="blockDisplay">
              <div
                class="displayedBlock"
                @click.stop="setPreviewIndex(index), shareProps(sharedData.data.props.rules[conditionIndex].conditionalBlock, emailData[sharedData.data.props.rules[index].conditionalBlock])"
              >
                {{ sharedData.data.props.rules[conditionIndex].conditionalBlock }}
              </div>
              <div class="deleteDisplayedBlock">
                <span class="material-symbols-outlined" @click="removeConditionalBlock(conditionIndex)">close</span>
              </div>
            </div>
          </div>
        </div>
        <button class="saveWizardRule" @click.prevent="pushRuleToEditor()">{{ $t('ConditionModal.PushToEditor') }}</button>
      </div>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters, mapState } from 'vuex';
  
  export default {
    name: "ConditionModal",
    props: ["ruleData", "sharedData", "conditionIndex"],
    data() {
      return {
        //condition: [],
      };
    },
    computed: {
      ...mapState(['xPathPlaceholders']),
      ...mapGetters(['getEmailData']),
      emailData() {
        return this.getEmailData;
      },
      placeholders() {
      return this.xPathPlaceholders.map(item => item.placeholder);
   },
      condition (){
        return  this.sharedData.data.props.rules[this.conditionIndex] 
      },
      ruleString: {
        get() {
        if (this.sharedData.data.props.rules[this.conditionIndex].operator == 'else') return 'Rule Editor not available for else conditions';
        return this.sharedData.data.props?.rules[this.conditionIndex].fullCondition || '';
      },
        set(value){
          if (!this.sharedData.data.props.rules[this.conditionIndex]) this.sharedData.data.props.rules[this.conditionIndex] = {};
          this.sharedData.data.props.rules[this.conditionIndex].fullCondition = value
      }
    }
    },
    methods: {
      ...mapActions(['updateActiveTab', 'updateAddState', 'addNewBlock', 'updateSharedData']),
      handleClick(item, index) {
        this.updateActiveTab('Inspect');
        this.updateAddState(item);
        this.addNewBlock({
          type: item,
          targetId: null,
          position: 'bottom',
          parentId: this.sharedData.id,
          parentType: 'Container'
        });
        const newBlockIndex = this.sharedData.data.props.childrenIds.length - 1;
        this.sharedData.data.props.rules[index].conditionalBlock = this.sharedData.data.props.childrenIds[newBlockIndex];
      },
      shareProps(id, data) {
        this.updateSharedData({ id, data });
      },
      setPreviewIndex(index) {
        this.sharedData.data.props.previewIndex = index;
      },
      removeConditionalBlock(index) {
        const blockId = this.sharedData.data.props.rules[index].conditionalBlock;
        const blockIndex = this.sharedData.data.props.childrenIds.indexOf(blockId);
        if (blockIndex !== -1) {
          this.sharedData.data.props.childrenIds.splice(blockIndex, 1);
        }
        this.sharedData.data.props.rules[index].conditionalBlock = null;
      },
      pushRuleToEditor(){
        const conditionPath = this.xPathPlaceholders.find(obj => obj.placeholder == this.condition?.statement).xpath
        this.ruleString = `${conditionPath}${this.condition?.operator}${this.condition?.value}`
      },
      closeModal() {
        this.$emit("close");
      }
    },
    mounted() {
      console.log('ConditionModal mounted', this.conditionIndex);
    }
  };
  </script>
  
<style scoped>
@import '../../styles/addComponents.css';
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: white;
  padding: 30px;
  border-radius: 8px;
  width: 500px;
  max-width: 100%;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.note{
  font-size: 13px;
}

ul {
width: 100%;
list-style-type: none;
padding: 0;
margin: 0;
margin-top: 10px;
display: flex;
flex-wrap: wrap;
justify-content: start;
}

li {
font-size: 12px;
width: 18%;
display: flex;
flex-direction: column;
align-items: center;
margin-bottom: 15px;
cursor: pointer;
padding-top: 5px;
}

.addIcon {
background:  var(--secondary-color);
color: white;
font-size: 25px;
padding: 3px 5px;
margin: 0px;
margin-bottom: 5px;
}

/* li:hover {
background-color: #f0f0f0; 
} */

.rule-editor {
  margin-bottom: 15px;
}

.divider{
  margin-bottom: 30px !important;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.setCondition{
  display: flex;
}

.operatorSelect {
  width: 30%
}

.valueInput {
  width: 70%
}

textarea {
  width : 100%;
  /* background: beige; */
  background: var(--secondary-color);
  color: white;
  resize: none;
  height: 80px;
}

label, .contentLabel {
  font-size: 13px;
}
.headings{
  font-size:16px;
}

input {
  margin-bottom: 10px;
}

select {
  margin-bottom: 10px;
}

.close-button{
  background: transparent;
  border: none;
  cursor: pointer;
}

.class-remove{
  font-size: 25px;
}

.saveWizardRule{
  background: var(--secondary-color);
  color: white;
  padding: 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
  </style>
  